import React, { useState } from "react";
import { Link } from "react-router-dom";
import useCurrentScreenWidth from "./Dimension";

const Footer = () => {
  let width = useCurrentScreenWidth();

  const [buttonStyle1, setButtonStyle1] = useState({
    width: 100,
    height: 50,
    borderRadius: 15,
    border: "none",
    backgroundColor: "whitesmoke",
    color: "#1877f3",
    cursor: "pointer",
    fontWeight: 700,
  });

  const [buttonStyle2, setButtonStyle2] = useState({
    width: 100,
    height: 50,
    borderRadius: 15,
    border: "none",
    backgroundColor: "whitesmoke",
    color: "#1877f3",
    cursor: "pointer",
    fontWeight: 700,
  });
  if (width > 600) {
    return (
      <footer
        style={{
          width: "100%",
          backgroundColor: "whitesmoke",
          textAlign: "center",
          paddingTop: "15px",
          paddingBottom: "15px",
        }}
      >
        <div style={{ marginLeft: "30px", marginRight: "30px" }}>
          <div>
            <img
              src="/logo2-2.png"
              height="45px"
              alt="logo2-2"
              style={{ marginTop: "30px" }}
            />
          </div>
          <div style={{ marginTop: "30px" }}>
            &copy; 2021. <Link to="/u/me" style={{ color: "#1877f3" }}>Shawn L</Link>. All
            rights reserved.
          </div>
        </div>
      </footer>
    );
  } else {
    return (
      <footer
        style={{
          width: "100%",
          backgroundColor: "whitesmoke",
          textAlign: "center",
          paddingTop: "5px",
          position: "fixed",
          bottom: 0,
        }}
      >
        <div style={{ height: "100%", textAlign: "center" }}>
          <Link
            to="/"
            style={{
              lineHeight: "60px",
            }}
          >
            <button
              style={buttonStyle1}
              onMouseDown={() => {
                setButtonStyle1({
                  width: 100,
                  height: 50,
                  borderRadius: 15,
                  border: "none",
                  backgroundColor: "silver",
                  color: "#1877f3",
                  cursor: "pointer",
                  fontWeight: 700,
                });
              }}
              onMouseUp={() => {
                setButtonStyle1({
                  width: 100,
                  height: 50,
                  borderRadius: 15,
                  border: "none",
                  backgroundColor: "whitesmoke",
                  color: "#1877f3",
                  cursor: "pointer",
                  fontWeight: 700,
                });
              }}
            >
              Home
            </button>
          </Link>
          <Link
            to="/popular"
            style={{
              lineHeight: "60px",
            }}
          >
            <button
              style={buttonStyle2}
              onMouseDown={() => {
                setButtonStyle2({
                  width: 100,
                  height: 50,
                  borderRadius: 15,
                  border: "none",
                  backgroundColor: "silver",
                  color: "#1877f3",
                  cursor: "pointer",
                  fontWeight: 700,
                });
              }}
              onMouseUp={() => {
                setButtonStyle2({
                  width: 100,
                  height: 50,
                  borderRadius: 15,
                  border: "none",
                  backgroundColor: "whitesmoke",
                  color: "#1877f3",
                  cursor: "pointer",
                  fontWeight: 700,
                });
              }}
            >
              Popular
            </button>
          </Link>
        </div>
        <div
          style={{
            color: "#dfdfdf",
            fontSize: 10,
            position: "fixed",
            bottom: 5,
            left: 5,
          }}
        >
          &copy; 2021. <Link to="/u/me" style={{ color: "#1877f3" }}>Shawn L</Link>. All
          rights reserved.
        </div>
      </footer>
    );
  }
};

export default Footer;
